import ReactGA from 'react-ga4';

export const GAInit = () => {
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID);
};

export const GASendEvent = (eventPath: GAEventPath, label?: string, value = 0, nonInteraction?: boolean) => {
  const [category, action] = eventPath.split('.');
  const event = GAEvents[category][action];

  if (!event) {
    console.error('Invalid event path:', eventPath);
    return;
  }

  const eventObject: IGAEventObject = {
    category: event.category,
    action: event.action,
    label,
    value,
    nonInteraction,
  };

  ReactGA.event(eventObject);
};

export const GAEvents: IGAEvents = {
  SUCCESS: {
    FORM_SUBMIT: {
      category: 'Success',
      action: 'form_submit',
    },
  },
  ERROR: {
    FORM_SUBMIT: {
      category: 'Error',
      action: 'form_submit',
    },
    LOGIN: {
      category: 'Error',
      action: 'login',
    },
  },
  INTERACTION: {
    BUTTON_CLICK: {
      category: 'Interaction',
      action: 'click',
    },
    LOGOUT: {
      category: 'Interaction',
      action: 'logout',
    },
    LOGIN: {
      category: 'Interaction',
      action: 'login',
    },
  },
};

export enum GAEventPath {
  SUCCESS_FORM_SUBMIT = 'SUCCESS.FORM_SUBMIT',
  ERROR_FORM_SUBMIT = 'ERROR.FORM_SUBMIT',
  ERROR_LOGIN = 'ERROR.LOGIN',
  INTERACTION_BUTTON_CLICK = 'INTERACTION.BUTTON_CLICK',
  INTERACTION_LOGIN = 'INTERACTION.LOGIN',
  INTERACTION_LOGOUT = 'INTERACTION.LOGOUT',
}

interface IGAEventObject {
  category: string;
  action: string;
  label?: string | undefined;
  value?: number | undefined;
  nonInteraction?: boolean;
}

interface IGAEvents {
  [key: string]: {
    [key: string]: IGAEventObject;
  };
}
